import React, { useState } from "react";
import { Link } from "react-router-dom";
import Input from "../common/Input";
import { STATUS } from "../common/Const";
import { email as emailValidation, mandatory, validateValues } from "../common/Validations";
import { hasNoErrors } from "../common/Helpers";
import API from "../../services/UserService";

const validationConfig = {
  email: {
    label: "Email",
    validate: [mandatory, emailValidation],
  },
};

const neutralMessage = "Jeśli konto istnieje, wysłaliśmy link do resetu hasła.";

const PasswordResetRequest = () => {
  const [formData, setFormData] = useState({ email: "" });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [status, setStatus] = useState(STATUS.IDLE);
  const [message, setMessage] = useState("");

  const validate = (values = formData) => {
    const nextErrors = validateValues(values, validationConfig);
    setErrors(nextErrors);
    return hasNoErrors(nextErrors);
  };

  const handleChange = (event) => {
    const nextFormData = { ...formData, [event.target.name]: event.target.value };
    setFormData(nextFormData);
    validate(nextFormData);
  };

  const handleBlur = (event) => {
    setTouched({ ...touched, [event.target.name]: true });
    validate();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setStatus(STATUS.SUBMITTING);
    setTouched({ email: true });

    if (!validate()) {
      setStatus(STATUS.SUBMITTED);
      return;
    }

    API.requestPasswordReset(formData.email)
      .then(() => {
        setMessage(neutralMessage);
        setStatus(STATUS.COMPLETED);
      })
      .catch(() => {
        setMessage(neutralMessage);
        setStatus(STATUS.COMPLETED);
      });
  };

  const displayedEmailError = touched.email || status === STATUS.SUBMITTED ? errors.email : undefined;

  return (
    <div className="quiz-text">
      <h2><strong>Reset hasła</strong></h2>
      {message && <div className="alert alert-info" role="alert">{message}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="col-md-9 col-lg-7">
            <Input
              label="Email"
              name="email"
              value={formData.email}
              error={displayedEmailError}
              placeholder="Email"
              onBlur={handleBlur}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 mb-2">
            <button type="submit" className="btn manage-button manage-red-button btn-block" disabled={status === STATUS.SUBMITTING}>Wyślij link</button>
          </div>
          <div className="col-md-3">
            <Link className="btn manage-button manage-teal-button btn-block" to="/manage">Wróć</Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PasswordResetRequest;
